export default {
      id: "oc-chinaunion-usage",
      viewBox: "0 0 254 196",
      url: __webpack_public_path__ + "sprite.svg#oc-chinaunion",
      toString: function () {
        return this.url;
      }
    }